import CryptoJS from 'crypto-js'
import crypto from 'crypto-browserify'

/**
 * AES
 * @param {any} data 暗号化対象データ
 * @param {string} key 暗号化キー(BASE64)
 * @return {string} 暗号化データ
 */
const encryptAES = (data, key) => {
  const parsedKey = CryptoJS.enc.Base64.parse(key)
  const parseStr = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
  const encrypted = CryptoJS.AES.encrypt(parseStr, parsedKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

/**
 * AES複合化
 * @param {string} encryptedData 暗号化データ
 * @param {string} key 複合化キー(BASE64)
 * @returns {any} 複合化データ
 */
const decryptAES = (encryptedData, key) => {
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedData)
  const parsedKey = CryptoJS.enc.Base64.parse(key)
  const cipher = CryptoJS.lib.CipherParams.create({ ciphertext })
  const decrypted = CryptoJS.AES.decrypt(cipher, parsedKey, { mode: CryptoJS.mode.ECB })
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

/**
 * ランダム文字列によるキー生成
 * @param {number} length キー長
 * @param {BufferEncoding} エンコード
 * @returns {string} キー
 */
const generateKey = (length = 16, encoding = 'base64') => {
  return crypto.randomBytes(length).toString(encoding)
}

export default {
  encryptAES,
  decryptAES,
  generateKey,
}
